import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    transactionList: [],
    transactionListCount: null,
    transactionFilter: {
        main_filter: null,
        fields: {
            transactionNumber: null,
            transactionCreatedAt: null,
            transactionAmount: null,
            transactionType: null,
            transactionArticle: null,
            transactionUserName: null,
            transactionUser: null,
            transactionCompanyTitle: null,
            filterStartDate: null,
            filterEndDate: null,
        },
    },
    supplement_amount: null,
    client_bank_receipt_file: null,
    bank_receipt_file: null,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
